import type { GenericRecordWithId } from '../../types';

type Items = GenericRecordWithId[];

const mapIds = (items: Items) => items.map((item: GenericRecordWithId) => item.id);

export default mapIds;
